import React from 'react';

import './index.css';
import TitleRoute from '../../components/titleRoute.js';
import Dashboard from './Dashboard';

const DashboardPage = () => {
  return (
    <div className='content'>
      <div className='main-container'>
        <div className='bottom-content-area'>
          <div className='tabs-content'>
            <div className='content'>
              <div className='allemails-area dashboard-page'>
                <div className='header-title-area'>
                  <div className='left-area'> <TitleRoute /> </div>
                </div>
                <Dashboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
